export const TeamData = {
  members: [
    {
      key: "1",
      name: "Rachit Kumar",
      position: "Chairperson ACM",
      linkedInURL: "www.linkedin.com/in/rachit-kumar-01559330b",
      githubURL: " https://github.com/Rachit1256",
      twitterURL: "",
      instaURL:"https://www.instagram.com/k.rachit._.12/",
      displayPicSrc: require("../assets/display-pics/rachit.jpeg")
    },
    {
      key: "2",
      name: "Shivangi Jha",
      position: "Vice Chairperson ACM",
      linkedInURL: "",
      githubURL: "",
      instaURL: "https://www.instagram.com/shivangieieieieie/",
      twitterURL: "",
      displayPicSrc: require("../assets/display-pics/shivangi.jpeg")
    },
    {
      key: "3",
      name: "Atif",
      position: "Chairperson ACM-W",
      linkedInURL: "",
      githubURL: "",
      instaURL:"https://www.instagram.com/krypton_here_/",
      twitterURL: "",
      displayPicSrc: require("../assets/display-pics/atif.jpeg")
     
    },
    {
      key: "4",
      name: "Lipakshi Juneja",
      position: "Vice Chairperson ACM-W",
      linkedInURL: "",
      githubURL: "",
      instaURL: "https://www.instagram.com/lipakshi2_6/",
      twitterURL: "",
      displayPicSrc: require("../assets/display-pics/lipakshi.jpeg")
    },
 
    {
      key: "5",
      name: "Anushka Goel",
      position: "WebMaster ACM",
      linkedInURL: "linkedin.com/in/anushka-goel-10333633b",
      githubURL: "https://github.com/Anushkagoel07",
      instaURL: "https://www.instagram.com/anushka_goel07/",
      twitterURL: "",
      displayPicSrc: require("../assets/display-pics/anushka.jpeg")
    },
    {
      key: "6",
      name: "Rishi Sharma",
      position: "General Secretary ACM",
      linkedInURL: "https://www.linkedin.com/in/rishi-sharma-b89486275?",
      githubURL: "https://github.com/Demonicdzire",
      twitterURL: "",
      instaURL:"https://www.instagram.com/rishiiii.sharmaa/",
      displayPicSrc: require("../assets/display-pics/rishi.jpeg")
    },
    // {
    //   key: "7",
    //   name: "Shwetank Chaudhary",
    //   position: "Joint Secretary ACM",
    //   linkedInURL: "https://www.linkedin.com/in/shwetank-chaudhary-b03ab520a/",
    //   githubURL: "https://github.com/hacker-kun",
    //   twitterURL: "",
    //   instaURL:"https://www.instagram.com/i.m.in_evi_t_able/",
    //   displayPicSrc: require("../assets/display-pics/Shewtank.jpg")
    // },
      
    // {
    //   key: "8",
    //   name: "Saurav Sakkarwal",
    //   position: "Joint Secretary ACM-W",
    //   linkedInURL: "https://www.linkedin.com/in/saurav-sakkarwal-185890217/",
    //   githubURL: "",
    //   twitterURL: "",
    //   instaURL: "https://www.instagram.com/saurav.0073/",
    //   displayPicSrc: require("../assets/display-pics/Saurav.jpg")
    // },

    {
      key: "9",
      name: "Lakshay Jangra ",
      position: "Treasurer ACM",
      linkedInURL: "https://www.linkedin.com/in/lakshay-jangra-258200385?",
      githubURL: "",
      // twitterURL: "",
      instaURL:"https://www.instagram.com/lakshay._.jangra/",
      displayPicSrc: require("../assets/display-pics/lakshay.jpeg")
    },

    {
      key: "10",
      name: "Harman Singh",
      position: "Membership Chair ACM",
      linkedInURL: "linkedin.com/in/harman-singh-5784581578055146219",
      githubURL: "https://github.com/DevHarman24",
      twitterURL: "",
      instaURL: "https://www.instagram.com/harmansingh_24k/",
      displayPicSrc: require("../assets/display-pics/harman.jpeg")
    }
  ],
  mentors: [
    
    {
      key: "12",
      name: "Prof. Sarita Yadav",
      displayPicSrc: require("../assets/display-pics/saritayadav.jpg")
    },
    {
      key: "13",
      name: "Vaibhav Choudhary",
      displayPicSrc: require("../assets/display-pics/Vaibhav.jpeg")
    }
    
  ]
};


export default TeamData 